// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { toggleFiltersStyles } from "@turnerBlueprint/App/Widgets/ToggleFilters/ToggleFiltersComponent";
import { styledBoxStyle } from "@turnerBlueprint/XDL/Components/Common/Box";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

toggleFiltersStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};
toggleFiltersStyles.toggleButton = {
    css: css`
        ${styledBoxStyle}
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        background-color: ${color("common.ui2")};
        padding: 9px 13px;
        &&&:focus {
            outline: none;
        }
        ${IconWrapper}.toggle-icon {
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 44px;
            border-left: 1px solid ${color("common.border")};
            background: ${color("common.ui2")};
            align-items: center;
            justify-content: center;
            svg {
                color: ${color("common.ui5")};
                height: auto;
            }
        }
        &[aria-expanded="true"] {
            padding-bottom: 10px;
        }
    `,
};

toggleFiltersStyles.zoneWrapper = {
    css: css`
        &[aria-expanded="true"] {
            border: 1px solid ${color("common.border")};
            border-top-width: 0;
            border-radius: 0 0 2px 2px;
        }

        .filter-zone-enter {
            overflow: hidden;
            max-height: 0;
        }

        .filter-zone-enter-active {
            max-height: 1000px;
            transition: max-height 0.6s ease-in-out;
        }

        .filter-zone-exit {
            max-height: 1000px;
        }

        .filter-zone-exit-active {
            overflow: hidden;
            max-height: 0;
            transition: max-height 0.4s cubic-bezier(0, 1, 0, 1);
        }

        &[aria-expanded="false"] > :not([class*="filter-zone"]),
        &[aria-expanded="false"] > :not([class*="filter-zone"]),
        .filter-zone-exit-done {
            overflow: hidden;
            max-height: 0;
        }
    `,
};
toggleFiltersStyles.text = {
    variant: "h3",
    css: css`
        margin: 0;
        color: ${color("text")};
    `,
};
